module.exports = __webpack_public_path__ + "media/images/alf_tick_green-c9f78b6bd3bcadeea36f8fa15199c49e.svg";